export const ruleTemplates = [`.%class%::-webkit-scrollbar { display: none }`];
